import {Injectable} from '@angular/core';
import {JuristischePerson, StammdatenJuristischePerson} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class JuristischePersonMapperService extends AbstractMapper<StammdatenJuristischePerson, JuristischePerson> {

  protected mapInternal(source: StammdatenJuristischePerson): JuristischePerson {

    return {
      firmenname: source.firmenname,
      artDesBetriebs: source.artDesBetriebs,
      gruedungsDatum: source.gruendungsdatum
    };
  }
}
